import { AppendableDataObject, DataObject } from "@/v2/models/base-data-object.js";
import { getAllClassMethods } from "@/v2/utils/object";

export class Column extends DataObject {
    _type = "column";

    id;
    label;
    title;
    subtitle;
    editable;
    disabled;
    searchable;
    relatedDocumentLink;
    orderable;
    computedRecord = false;
    visible = true;
    type;
    search;
    searchType; //Used for "select-with-search" for integration field
    resetAfterSearch;
    meta; //currency,datetime
    url;
    transformer; //Function to convert data to be input into column component
    recordEditable; //Function to determine if a record is editable
    additional_classes;
    for_sequence; //Marks this as the manual-sequence column for showSortFilterStatusBar consumers

    options; //select
    multiple;
    nullable;
    labels;
    plain;
    suffix_id; //select; id of another field on the record, rendered after the resolved label

    sign; //number
    min;
    max;
    displayMax;
    maxId;
    maxTransformer;
    negative;
    currency;
    decimal;
    eager;
    setToMinValue;
    numberSearch; //number; false = plain single-value text search instead of the range popup

    start_id; //date_range
    end_id;
    start_date_id; //date_range
    end_date_id; //date_range
    format;
    separator;
    defaultStartText;
    defaultEndText;
    defaultEmptyText;
    showSeparatorIfEmpty;
    includeEndDay;
    simple;
    show_tag;
    list_box; // render the value with bo-list-box; undeclared keys are dropped from the config
    list_box_fit_width; // list_box: show as many tags as fit in this many px, then "+N"
    columns;
    addRecordsUrl;
    addNewRecordUrl;
    display_id;
    primary_key;
    showNullIfEmpty;
    withTime;

    selectMultipleItem; //Multiselect

    showPopup; //Product

    placeholder; //datetime
    is_end_date; //datetime; stored value is the day after the displayed end date

    url; //link
    link; //function
    target = "_blank";

    // for show pop up in overview
    subcolumns;
    get_records_route;
    payload_parameters;
    show_pop_up;
    show_popup_button;

    customLink; //to set custom variable for link2 type
    customFilter; // custom filter for consolidated_under
    defaultCustomFilter; // custom filter

    v_html = true; // show text in v-html by default

    exportExcelUrl;

    show_tooltip; // for showing tooltip in column header
    tooltip_text;
    tooltip_placement;

    custom_trigger_method; // custom trigger method for general details page

    resetSearch() {
        this.search = "";
    }

    transform(record) {
        return this.transformer == null ? record[this.id] : this.transformer.call(this, record);
    }

    isRecordEditable(record) {
        if (this.recordEditable != null) {
            return this.recordEditable.call(this, record);
        }

        return this.editable;
    }

    maxTransform(record) {
        if (this.max != null) {
            return this.max;
        }

        if (this.maxId != null) {
            return record[this.maxId];
        }

        if (this.maxTransformer != null) {
            return this.maxTransformer.call(this, record);
        }

        return null;
    }

    getLink(record) {
        if (this.link != null) {
            return this.link.call(this, record);
        }
        return this.url;
    }
}

export class Record extends AppendableDataObject {
    checked = false;
    subrecordVisibility = false;
    subrecords = [];
    order;
    _originalProperties = ["checked", "subrecordVisibility", "subrecords", "order"];

    constructor(data = null) {
        super(data);

        if (data != null) {
            getAllClassMethods(data).forEach((method) => {
                this[method] = data[method];
            });

            if (data instanceof Record) {
                this.checked = data.checked;
                this.subrecordVisibility = data.subrecordVisibility;
                this.subrecord = data.subrecord;
                this.order = data.order;
            }
            this.subrecordVisibility = data.subrecordVisibility;
            this.subrecords = data.subrecords;
        }
    }

    toJSON() {
        let data = this.copy();

        return this.removeInternalProperties(data);
    }

    copy() {
        return new Record(this);
    }

    getFreshRecord() {
        let data = Object.assign({}, this);
        return new Record(this.removeInternalProperties(data));
    }

    removeInternalProperties(data) {
        for (const property of this._originalProperties) {
            delete data[property];
        }

        return data;
    }
}
